module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9539_violet.4044b58f.jpg";